const DOCUMENT_UPLOADS_SECTION = 'e920c5dc-d5db-44b2-9b3c-c4c94b4e759a'
const MAX_DESCRIPTION_LENGTH = 1500

export { DOCUMENT_UPLOADS_SECTION, MAX_DESCRIPTION_LENGTH }
